import { colors, HLine, Spacing } from "goi_common";
import { ParlorDetailProps } from "@/types/parlor";
import { Dispatch, SetStateAction } from "react";
import AmenityInfoTabPanel from "./AmenityInfoTabPanel";
import { PriceTopSection, GoiIntroSection } from "./PriceInfoTabPanel";

function TabInfoSection({
  parlor,
  selectedSangjo,
  setSelectedSangjo,
  discountDescription,
  closestParlors,
  nearbyFacilities,
  isExcluded,
}: {
  parlor: ParlorDetailProps;
  selectedSangjo: string;
  setSelectedSangjo: Dispatch<SetStateAction<string>>;
  discountDescription?: string;
  closestParlors: any;
  nearbyFacilities?: any;
  isExcluded?: boolean;
}) {
  return (
    <>
      <HLine height={1} color={colors.gray100} width="100%" />
      <PriceTopSection expectedCharges={parlor.expected_charge_sum} parlor={parlor} />
      <AmenityInfoTabPanel
        parlor={parlor}
        closestParlors={closestParlors}
        nearbyFacilities={nearbyFacilities}
      />

      <HLine height={8} color={colors.gray50} width="100%" />
      <Spacing gap={32} />

      <GoiIntroSection parlor={parlor} />
      <Spacing gap={120} />
    </>
  );
}

export default TabInfoSection;
